import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { isEnabled } from "lib/@components/feature"

import { FEATURE_FLAG_ASSET_MAPPING } from "routes/asset-register/feature-flag-asset-mapping"
import { InventoryCard } from "./inventory-card"
import { Box } from "@mui/material"
import { ScheduleAssetsTable } from "./schedule-assets-table"
import { UomInventoryRow } from "./uom-inventory-row"
import { useEffect } from "react"
import { usePlanRoot } from "lib/use-plan-root"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Repeat } from "lib/@components/repeat"

export function DisplayInventory() {
    const { schedule, payload, refetch } = useBoundContext()
    const unitsOfMeasurement = Object.keys(schedule.tasks.filter((t) => !t.isHeader).groupBy("unitOfMeasure")).filter(
        (c) => c !== "undefined"
    )
    const planRoot = usePlanRoot()
    const display =
        !!planRoot &&
        (isEnabled(FEATURE_FLAG_ASSET_MAPPING) || Object.values(payload?.units).some((u) => u > 1 || !!u?.id))
    const isSynced = !!payload?.assetRegisters?.length || !!payload?.register

    useEffect(() => {
        refetch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schedule])

    if (!payload) return null
    payload.units ??= {}
    if (payload.units.Nr && !unitsOfMeasurement.includes("Nr")) {
        unitsOfMeasurement.push("Nr")
    }

    return (
        display && (
            <Bound target={payload.units}>
                <If value={isSynced}>
                    <Box>
                        <Box my={2} mx={0.5}>
                            <InventoryCard>
                                <ScheduleAssetsTable />
                            </InventoryCard>
                        </Box>
                    </Box>
                    <Else>
                        <Repeat list={unitsOfMeasurement} item={<UomInventoryRow />} pass="uom" />
                    </Else>
                </If>
            </Bound>
        )
    )
}
